export default httpClient => ({
  save: async ({ nome, valor, link, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/redes-sociais', { nome, valor, link }, { headers })
    return {
      data: response.data,
    }
  },
  update: async ({ id, nome, valor, link, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.patch('/redes-sociais/' + id, {
      id,
      nome,
      valor,
      link,
    }, { headers });
    return {
      data: response.data
    }
  },
  getById: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/redes-sociais/' + id, { headers });
    return {
      data: response.data
    }
  },
  getAll: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/redes-sociais', { headers });
    return { data: response.data }
  },
  delete: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/redes-sociais/' + id, { headers });
    return {
      data: response
    }
  },
});